export const validateUserPassword = (string: string): boolean => {

    const lengthValidation: boolean = string.length > 7;
    const numberValidation: boolean = string.match(/\d/g) ? true : false;
    const lettersValidation: boolean = string.match(/[a-z]/) && string.match(/[A-Z]/) ? true : false;
    const specialCharsValidation: boolean = string.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/) ? true : false;

    return lengthValidation && numberValidation && lettersValidation && specialCharsValidation;

};


export default validateUserPassword;
